import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getBookOptions } from '@/module/Author/Book';
import { BookEdit } from '@/module/Author/Book/BookEdit';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { bookId } = Route.useParams();
  const { data: book } = useSuspenseQuery(getBookOptions(bookId));

  return <BookEdit book={book} />;
}
